var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_11284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7075 7.2925L16.7075 0.2925C16.52 0.105 16.265 0 16 0H3C1.345 0 0 1.345 0 3V21C0 22.655 1.345 24 3 24H21C22.655 24 24 22.655 24 21V8C24 7.735 23.895 7.48 23.7075 7.2925ZM10 2H14V6H10V2ZM18 22H6V14H18V22ZM22 21C22 21.55 21.5525 22 21 22H20V13C20 12.4475 19.5525 12 19 12H5C4.4475 12 4 12.4475 4 13V22H3C2.4475 22 2 21.5525 2 21V3C2 2.45 2.4475 2 3 2H8V7C8 7.5525 8.4475 8 9 8H15C15.5525 8 16 7.5525 16 7V2.415L22 8.415V21Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_11284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveOutlined);
export default __webpack_public_path__ + "static/media/SaveOutlined.8c1229df.svg";
export { ForwardRef as ReactComponent };